import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from 'src/app/services/message.service';
import { UserAffiliateRatioDialogComponent } from '../user-affiliate-ratio-dialog/user-affiliate-ratio-dialog.component';

@Component({
  selector: 'app-user-affiliate-share-card',
  templateUrl: './user-affiliate-share-card.component.html',
  styleUrls: ['./user-affiliate-share-card.component.scss'],
})
export class UserAffiliateShareCardComponent {
  @Input() data: any;

  constructor(
    private clipboard: Clipboard,
    private message: MessageService,
    private dialog: MatDialog
  ) {}

  sharelink() {
    return 'http://cn.goingbus.com?s=' + this.data?.code;
  }

  copylink() {
    this.clipboard.copy(this.sharelink());
    this.message.open('复制成功');
  }

  viewRatio() {
    this.dialog.open(UserAffiliateRatioDialogComponent, {
      autoFocus: false,
      panelClass: 'app-dialog',
    });
  }
}
